/**
 * Pathfinder rule overrides.
 *
 * Card text (verbatim from sorcery-cards.json):
 *   "Your atlas can't contain duplicates. Draw no sites during setup.
 *    Tap → If able, play the topmost site of your atlas to an adjacent
 *    location and move there."
 *
 * Three rules, three different homes:
 *
 *   1. "Your atlas can't contain duplicates." Deckbuilding rule,
 *      handled below via `atlasMaxCopies: 1`. Enforced at deck save /
 *      match-entry time by `deckRules.js`. No in-match effect.
 *
 *   2. "Draw no sites during setup." Opening-hand modifier, atlas
 *      opening draw = 0 (default is 3). The atlas deck still exists;
 *      the player pulls sites via the Tap ability during play.
 *
 *   3. "Tap → If able, play the topmost site..." REPLACES the
 *      standard "Tap → Play or draw a site" builtin every avatar
 *      carries. Wired via the sidecar entry (op `pathfinder_tap`).
 *      `replacesBuiltinAvatarSite: true` tells GameBoard's
 *      `_activatedEntriesFor` to suppress the builtin so the action
 *      menu only surfaces this avatar's actual tap ability.
 */
export const PATHFINDER_RULES = {
  openingHand: {
    atlas: 0,
  },
  deckbuilding: {
    atlasMaxCopies: 1,
  },
  replacesBuiltinAvatarSite: true,
};
